import { Component } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { HelpService } from '../../../services/help.service';

@Component({
    selector: 'lex-third-party',
    templateUrl: './third-party.component.html',
    styleUrls: ['./third-party.component.scss'],
    standalone: false
})
export class ThirdPartyAppComponent extends BaseComponent {
	constructor(private helpService: HelpService) {
		super();
		this.helpService.updateHelpLink('management-menu/third-party-applications');
	}
}
